<div class="h-[100dvh] lg:h-screen w-full">
  <div
    class="relative h-full w-full flex justify-center items-center rounded-br-[225px] md:rounded-br-[350px] overflow-hidden shadow-2xl">
    <img
      class="hidden md:block h-full w-full object-cover brightness-90"
      src="assets/auctions/images/pw-licytacje-banner.jpg"
      alt="auctions-hero-banner">
    <img
      class="block md:hidden h-full w-full object-cover brightness-90"
      src="assets/auctions/images/pw-licytacje-banner-mobile.webp"
      alt="auctions-hero-banner-mobile">
    <div
      class="absolute left-0 top-0 h-screen w-full">
      <div
        class="relative max-w-[1000px] mx-auto h-full text-6xl md:text-14xl xl:text-20xl font-extrabold text-center">
        <div
          class="w-full px-5 absolute h-auto top-[20vh] sm:top-[24vh] md:top-[15vh] flex flex-col items-center justify-center">
          <h1 class="text-secondary-750 font-secondary leading-[fit-content] md:leading-20">
          Samochód <br class="block sm:hidden"> do firmy <br> bez zbędnych formalności
          <span class="text-primary-500 text-xl sm:text-8xl xl:text-10xl">
            <br>
            @if (isBrowser) {
              <om-shiny-text [text]="'leasing dostępny od ręki'" styleClass="shiny-text-auctions"></om-shiny-text>
            }
          </span>
        </h1>
        </div>
        <div class="absolute bottom-32 sm:bottom-24 w-full flex justify-center whitespace-nowrap">
          <p-button
            [navigator]="auctionsFormComponentSignal()?.id"
            (navigatorEmitter)="onCtaClick()"
            label="Wyślij zapytanie"
            styleClass="text-sm extra-padding whitespace-nowrap"
            rounded="true">
          </p-button>
        </div>
      </div>
    </div>
  </div>
</div>
